import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/components/ThemeProvider";
import { I18nProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MICAAssistant from "@/components/MICAAssistant";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import FileClaim from "@/pages/FileClaim";
import TrackClaim from "@/pages/TrackClaim";
import ClaimDetail from "@/pages/ClaimDetail";
import DocumentVault from "@/pages/DocumentVault";
import KnowledgeCenter from "@/pages/KnowledgeCenter";
import AdminDashboard from "@/pages/AdminDashboard";
import PartnerDashboard from "@/pages/PartnerDashboard";
import WorkshopPortal from "@/pages/WorkshopPortal";
import ClaimManagerPanel from "@/pages/ClaimManagerPanel";
import Rewards from "@/pages/Rewards";
import AdminAnalytics from "@/pages/AdminAnalytics";
import InsurerLanding from "@/pages/InsurerLanding";
import WarRoom from "@/pages/WarRoom";
import AuditTrail from "@/pages/AuditTrail";
import WorkshopManagement from "@/pages/WorkshopManagement";
import Finance from "@/pages/Finance";
import Emergency from "@/pages/Emergency";
import PartnerNetwork from "@/pages/PartnerNetwork";
import Enterprise from "@/pages/Enterprise";
import Legal from "@/pages/Legal";

function AppShell() {
  const location = useLocation();

  // CRITICAL: Handle session_id in URL fragment synchronously before normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/file-claim" element={<FileClaim />} />
          <Route path="/track" element={<TrackClaim />} />
          <Route path="/knowledge" element={<KnowledgeCenter />} />
          <Route path="/knowledge/:slug" element={<KnowledgeCenter />} />
          <Route path="/emergency" element={<Emergency />} />
          <Route path="/partners" element={<PartnerNetwork />} />
          <Route path="/enterprise" element={<Enterprise />} />
          <Route path="/insurer/:slug" element={<InsurerLanding />} />
          <Route path="/legal/:section" element={<Legal />} />
          <Route path="/about" element={<Legal />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/claim/:claimId" element={<ProtectedRoute><ClaimDetail /></ProtectedRoute>} />
          <Route path="/vault" element={<ProtectedRoute><DocumentVault /></ProtectedRoute>} />
          <Route path="/rewards" element={<ProtectedRoute><Rewards /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute adminOnly><AdminAnalytics /></ProtectedRoute>} />
          <Route path="/admin/war-room" element={<ProtectedRoute adminOnly><WarRoom /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute adminOnly><AuditTrail /></ProtectedRoute>} />
          <Route path="/admin/workshops" element={<ProtectedRoute adminOnly><WorkshopManagement /></ProtectedRoute>} />
          <Route path="/admin/finance" element={<ProtectedRoute adminOnly><Finance /></ProtectedRoute>} />
          <Route path="/partner-dashboard" element={<ProtectedRoute><PartnerDashboard /></ProtectedRoute>} />
          <Route path="/workshop" element={<ProtectedRoute><WorkshopPortal /></ProtectedRoute>} />
          <Route path="/claim-manager" element={<ProtectedRoute><ClaimManagerPanel /></ProtectedRoute>} />
        </Routes>
      </main>
      <MICAAssistant />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
